import {
  FormControlLabel,
  Checkbox,
  FormHelperText,
  FormControl,
} from "@mui/material";
import { Controller, useFormContext, } from "react-hook-form";
import { useConditionalVisibility } from '../../../_hooks/useConditionalVisibility';

const CustomCheckboxField = ({ question }) => {  
    const { label = "", fieldId, rules, textFieldKey, defaultValue,disable, isHidden} = question;
  const { control, formState: { errors }} = useFormContext();

  const isVisible = useConditionalVisibility(question.dependantConditions );
  if (!isVisible && isHidden) return null;

  return (
    <FormControl
      error={!!errors[fieldId] || !!errors[textFieldKey]}
      component="fieldset"
      sx={{ m: 0, display: "flex", flexDirection: "column" }}
    >
      <Controller
        name={fieldId}
        control={control}
        rules={rules}
        defaultValue={defaultValue}
        render={({ field }) => (
          <FormControlLabel
            label={label}
            control={
              <Checkbox
                {...field}
                checked={!!field.value}
                disabled={disable}
                onChange={(e) => field.onChange(e.target.checked)}
                size="small"
              />
            }
            sx={{ m: 0 }}
          />
        )}
      />
      <FormHelperText>{errors[fieldId]?.message}</FormHelperText>
    </FormControl>
  );
};

export default CustomCheckboxField;
